import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeo, seoHead } from "../seo";

export function Seo() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const seo = getSeo(pathname);
    document.documentElement.lang = seo.locale;
    // Exactly the same metadata generator is used by the static HTML build.
    document.head.querySelectorAll("[data-seo]").forEach(node => node.remove());
    const template = document.createElement("template"); template.innerHTML = seoHead(seo);
    document.head.append(template.content);
  }, [pathname]);
  useEffect(() => {
    // Preserve legal contents/deep links when a pre-rendered page hydrates.
    // Malformed or unknown fragments must not throw or force a jump to the top.
    if (hash) {
      let id: string;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
      document.getElementById(id)?.scrollIntoView({ block: "start" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
